var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 3894",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 450",
    d: "M4.481 6.555h2.037v1.018H7.74V6.555h4.482v1.018h1.222V6.555h2.037v4.278h1.222v-5.5h-3.259V3.525a1.454 1.454 0 00-1.452-1.452H7.974a1.454 1.454 0 00-1.452 1.452v1.807H3.263v11.816h8.759v-1.223H4.485zm3.259-3.03a.231.231 0 01.23-.23h4.022a.231.231 0 01.23.23v1.807H7.74z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 451",
    d: "M17.73 13.656h-2.269v-2.269h-1.222v2.269H11.97v1.222h2.269v2.269h1.222v-2.269h2.269z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBag);
export default __webpack_public_path__ + "static/media/icon_bag.67d2dfe8910b6067d81614d0c3804193.svg";
export { ForwardRef as ReactComponent };